export default __webpack_public_path__ + "static/measurements_placeholder-2ea004373810c99229d477855b4e753a.png";